<!--

<div class="container" style="background-color: white;">
    <div class="col-md-12">
        <h5 class="form-lable">Choose Excel file</h5>
        <div class="profile-form-edit">
            <div class="upload-btn-wrapper mt-3">
                <div style="width:25%; display:flex;"><input type="file" (change)="onFileChange($event)" #fileControl multiple="false" accept=".xlsx" />
                <i style="color:red;" class="fa fa-window-close" (click)="closeExcel()" aria-hidden="true"></i></div>
                <a href="assets/Sample_excel2.xlsx" download="" class="btn btn-primary"
                    style="margin: 10px;margin-left: 0px;float: right;margin-top: -27px;">Download Sample
                    Document</a>
                <br>
                <a class="btn btn-primary" (click)="checknow()" style="margin-left: 0px;float: right; background-color: #747f7f;">Generate Code</a>
                <a class="btn btn-primary" (click)="exportAsXLSX()" style="margin-left: 0px;float: right; background-color: #747f7f;">Export Data</a>
            </div>
        </div>
    </div>
        <div class="col-md-12" style="padding: 45px;">
        <table style="width:100%">
            <tr>
              <th>Acc_no</th>
              <th>Passport_no</th>
              <th>Fint_no</th>
              <th>allocation_status</th>
              <th>User Id</th>
            </tr>
            <ng-container *ngFor="let item of excel_data; let i = index">
                <tr>
                    <td>{{item.acc_no}}</td>
                    <td>{{item.passport_no}}</td>
                    <td>{{item.fint_id}}</td>
                    <td>{{item.allocation_check}}</td>
                    <td>{{item.user_id}}</td>
                  </tr>
              </ng-container>
          </table>
        </div>
    <div class="centered" style="width: 100%;background: #000000b3;height: -webkit-fill-available;" *ngIf="loader_status">
            <p><img class="imgs" src="../../../../assets/loader.gif" style="width: 10%;"></p>
            <p style="text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: white;"> Completed {{excel_data.length - 1 - timeLeft}} / {{excel_data.length}} <p>
    </div>
    </div> -->






<div class="container" style="background-color: white;">
    <div class="col-md-12">
        <h5 class="form-lable">Choose Excel file</h5>
        <div class="profile-form-edit">
            <div class="upload-btn-wrapper mt-3">
                <div style="width:25%; display:flex;"><input type="file" (change)="onFileChange($event)" #fileControl multiple="false" accept=".xlsx" />
                <i style="color:red;" class="fa fa-window-close" (click)="closeExcel()" aria-hidden="true"></i></div>
                <a href="assets/Sample_excel2.xlsx" download="" class="btn btn-primary"
                    style="margin: 10px;margin-left: 0px;float: right;margin-top: -27px;">Download Sample
                    Document</a>
                <br>
                <a class="btn btn-primary" (click)="check_data()" style="margin-left: 0px;float: right; background-color: #747f7f;">Generate Code</a>
                <a class="btn btn-primary" (click)="exportAsXLSX()" style="margin-left: 0px;float: right; background-color: #747f7f;">Export Data</a>
            </div>
        </div>
    </div>
        <div class="col-md-12" style="padding: 45px;">
        <table style="width:100%">
            <tr>
              <th>Acc_no</th>
              <th>fint_id</th>
              <th>passport_no</th>
              <th>User Id</th>
              <th>allocation_status</th>
              <th>email id</th>
            </tr>
            <ng-container *ngFor="let item of excel_data; let i = index">
                <tr>
                    <td>{{item.acc_no}}</td>
                    <td>{{item.fint_id}}</td>
                    <td>{{item.passport_no}}</td>
                    <td>{{item.user_id}}</td>
                    <td>{{item.allocation_check}}</td>
                    <td>{{item.email}}</td>
                  </tr>
              </ng-container>
          </table>
        </div>
    <div class="centered" style="width: 100%;background: #000000b3;height: -webkit-fill-available;" *ngIf="loader_status">
            <p><img class="imgs" src="../../../../assets/loader.gif" style="width: 10%;"></p>
            <p style="text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: white;"> Please wait... {{excel_data.length - 1}} / {{excel_data.length}} <p>
    </div>
    </div>
